/*
 * @Description  : cookie 相关的工具文件
 * @usage        :
 * @Date         : 2021-11-04 12:09:36
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-07 11:45:37
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/cookie.ts
 */

import { IS_SSR } from './env';

/**
 * 获取 cookie 中 key 对应的 value
 * 备注：迁移自 @tencent-wsl/cookie
 * @export
 * @param {string} key
 * @param {string} [oriCookie]
 * @return {*}
 */
export function getCookie(key: string, oriCookie?: string) {
  let cookie = typeof oriCookie !== 'string' ? '' : oriCookie;
  if (!IS_SSR) {
    cookie = typeof oriCookie === 'undefined' ? document.cookie : '';
  }

  const r = new RegExp(`(?:^|;\\s*)${key}=([^;]*)`);
  const m = cookie.match(r);
  return m?.[1] || '';
};
